// extracted by mini-css-extract-plugin
export var logo = "_bf-2";
export var logoWrapper = "_bf-1";
export var strip = "_bf-0";